import axios from "axios";
import { apiURL } from './api.js';

export const getIP = async () => {
    try {
        const response = await axios.get('https://api.ipify.org?format=json');
        return response.data.ip;
    } catch (error) {
        console.error('Error getting IP:', error);
        return null;
    }
};

// Function to send contact form email
export const sendContactEmail = async (formData, language = 'fr') => {
    try {
        if (!formData.email || !formData.name || !formData.message) {
            throw new Error('Name, email, and message are required');
        }

        const payload = {
            name: formData.name,
            email: formData.email,
            subject: formData.subject || 'Contact Form Submission',
            message: formData.message,
            language: language
        };
        
        const response = await axios.post(`${apiURL}/contact/send`, payload, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'X-Forwarded-For': await getIP()
            }
        });
        
        if (response.status !== 200 && response.status !== 201) {
            throw new Error('Failed to send contact email');
        }
        
        return response.data;
    } catch (error) {
        console.error('Error sending contact email:', error);
        throw error;
    }
};
